<rcp-button-expandable-overlay [icon]="icon">
  <div class="overlay-button-label">
    @if (!activeFilterLabels?.length) {
      {{ defaultLabel }}
    }
    @for (activeFilterLabel of activeFilterLabels; track activeFilterLabel) {
      <rcp-label>{{ activeFilterLabel }}</rcp-label>
    }
    @if (activeFilterLabels?.length) {
      <fa-icon (click)="emitClearFilter($event)" [icon]="faCircleXmark" class="text reset-filter"> </fa-icon>
    }
  </div>

  <ng-content></ng-content>
</rcp-button-expandable-overlay>
